function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenu = function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M0 18a1 1 0 0 1 1-1h19a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    y: 11,
    fill: props.color,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M0 6a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"
  }));
};
export default SvgIconMenu;